import { useMemo } from 'react'
import { useWizard } from '@/components/common/wizard/WizardContext'
import { getAvailableStages } from '@/utils/ad-campaigns-helpers'

/**
 * Custom hook for getting read-only funnel data
 * @returns {Object} Read-only funnel data
 */
export const useFunnel = () => {
    const { getStepContentData } = useWizard()

    // Get campaign objective data
    const selectFormatData = getStepContentData('campaignObjective') || {}
    const selectedObjective = selectFormatData.selectedObjective?.toLowerCase() ?? 'awareness'

    // Get sales funnel setup data
    const salesFunnelData = getStepContentData('salesFunnelSetup') || {}
    const audienceSelections = salesFunnelData.audienceSelections || {}

    // Calculate available stages based on objective
    const availableStages = useMemo(() => {
        return getAvailableStages(selectedObjective)
    }, [selectedObjective])

    return {
        availableStages,
        audienceSelections,
    }
}

export default useFunnel
